var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24.394",
      "height": "28.932",
      "viewBox": "0 0 24.394 28.932"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "data-name": "Groupe 1369",
      "fill": "none",
      "stroke": "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  }, [_c('path', {
    attrs: {
      "data-name": "Tracé 1278",
      "d": "M12.197 27.932V1"
    }
  }), _c('path', {
    attrs: {
      "data-name": "Tracé 1279",
      "d": "M22.979 11.783L12.197 1 1.414 11.783"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }